// اللَّهُ لَا إِلَٰهَ إِلَّا هُوَ الْحَيُّ الْقَيُّومُ ۚ لَا تَأْخُذُهُ سِنَةٌ وَلَا نَوْمٌ ۚ
// لَهُ مَا فِي السَّمَاوَاتِ وَمَا فِي الْأَرْضِ ۗ مَنْ ذَا الَّذِي يَشْفَعُ عِنْدَهُ إِلَّا بِإِذْنِهِ ۚ
// يَعْلَمُ مَا بَيْنَ أَيْدِيهِمْ وَمَا خَلْفَهُمْ ۖ وَلَا يُحِيطُونَ بِشَيْءٍ مِنْ عِلْمِهِ إِلَّا بِمَا شَاءَ ۚ
// وَسِعَ كُرْسِيُّهُ السَّمَاوَاتِ وَالْأَرْضَ ۖ وَلَا يَئُودُهُ حِفْظُهُمَا ۚ وَهُوَ الْعَلِيُّ الْعَظِيمُ
// (Bakara 255)

import { apiClient } from './client';
import type { ThemeMetadata } from '@/lib/themes/types';

export interface ResolvedThemeDto {
  platformJson: string;
  tenantJson: string;
  userJson: string;
  colorMode: 'light' | 'dark' | 'auto';
  locale?: string | null;
}

export async function fetchResolvedTheme(): Promise<ResolvedThemeDto> {
  const { data } = await apiClient.get<ResolvedThemeDto>('/api/theme/resolved');
  return data;
}

export async function fetchPlatformTheme(): Promise<ThemeMetadata | null> {
  const { data } = await apiClient.get<{ themeJson: string }>('/api/theme/platform');
  return parseTheme(data.themeJson);
}

export async function fetchTenantTheme(): Promise<ThemeMetadata | null> {
  const { data } = await apiClient.get<{ themeJson: string }>('/api/theme/tenant');
  return parseTheme(data.themeJson);
}

export async function savePlatformTheme(theme: ThemeMetadata): Promise<void> {
  await apiClient.put('/api/theme/platform', { themeJson: JSON.stringify(theme) });
}

export async function saveTenantTheme(theme: ThemeMetadata): Promise<void> {
  await apiClient.put('/api/theme/tenant', { themeJson: JSON.stringify(theme) });
}

export async function saveUserPref(colorMode: 'light' | 'dark' | 'auto'): Promise<void> {
  await apiClient.put('/api/theme/user/me', { colorMode });
}

// Kullanicinin sectigi temayi kendi tercihine kaydet (Cortex tarzi). null => tenant temasina don.
export async function saveUserTheme(theme: ThemeMetadata | null): Promise<void> {
  await apiClient.put('/api/theme/user/me', { themeJson: theme ? JSON.stringify(theme) : '' });
}

function parseTheme(json: string): ThemeMetadata | null {
  if (!json || json === '{}') return null;
  try {
    return JSON.parse(json) as ThemeMetadata;
  } catch {
    return null;
  }
}
